// React
import { useState, useEffect } from 'react'

// i18n
import { useTranslation } from 'react-i18next'

// Interfaces
import { IBaseOtpResendProps } from './interfaces'

const BaseOtpResend = ({ onResend, disabled }: IBaseOtpResendProps) => {
  // Hook
  const [resendCodeTime, setResendCodeTime] = useState<number>(30)
  const [isUserRequestResendCode, setIsUserRequestResendCode] = useState<boolean>(false)
  const { t } = useTranslation()

  useEffect(() => {
    let timer: any
    let decrease: number = 30
    if (isUserRequestResendCode) {
      timer = setInterval(() => {
        setResendCodeTime((decrease -= 1))

        if (decrease === 0) {
          clearTimeout(timer)
          setResendCodeTime(5)
          setIsUserRequestResendCode(false)
        }
      }, 1000)
    }

    return () => {
      if (isUserRequestResendCode) clearTimeout(timer)
    }
  }, [isUserRequestResendCode])

  /**
   * @description Resend verification code
   *
   * @return {void} void
   */
  const onResendVerificationCode = () => {
    if (!isUserRequestResendCode) {
      setIsUserRequestResendCode(true)

      onResend()
    }
  }

  return (
    <div className="flex flex-col md:flex-row text-center">
      <p className="font-weight-400">{t('auth.otpVerification.notReceiveCode')}</p>
      <p
        className={`text-${disabled ? 'grey' : 'primary'} font-weight-700 md:ml-1 ${
          isUserRequestResendCode ? '' : 'cursor-pointer'
        }`}
        onClick={() => (disabled ? true : !isUserRequestResendCode ? onResendVerificationCode() : false)}
      >
        {isUserRequestResendCode
          ? `${t('auth.otpVerification.tryAgainAt')} ${resendCodeTime} ${t('app.seconds')}`
          : t('auth.otpVerification.resend')}
      </p>
    </div>
  )
}

export { BaseOtpResend }
